import { render } from "./vocabulary.vue?vue&type=template&id=7912c1ea"
import script from "./vocabulary.vue?vue&type=script&lang=js"
export * from "./vocabulary.vue?vue&type=script&lang=js"

import "./vocabulary.vue?vue&type=style&index=0&id=7912c1ea&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/funfindhk20250610/front-vue-src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__